module.exports = __webpack_public_path__ + "static/media/img_25.65e1eae5.png";